import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';

export interface ResultCountProps {
  count: number;
}

/**
 * How many rows a list currently shows. Callers pass `filteredSorted.length`
 * (see `useTableFilters`) so the number narrows as filters are applied.
 */
export function ResultCount({ count }: ResultCountProps): JSX.Element {
  return (
    <Badge variant="secondary" data-testid="result-count" aria-label={`${count} results`}>
      {count}
    </Badge>
  );
}
